// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3LZkS","rootSmall":"AddTileButton_rootSmall__2JKJC"};